<div class="flex flex-col h-full w-full overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center p-4 h-auto">
        <!-- Logo -->
        <div class="w-30 h-auto">
            <img class="w-90 h-auto" src="images/logo/logo.svg" />
        </div>
  
        <!-- Close button -->
        <button mat-icon-button mat-dialog-close (click)="close()" class="icon-size-2" *ngIf="shouldShowCloseButton()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
  
    <!-- Instructions -->
    <div class="flex-grow flex flex-col justify-between items-center px-4 md:px-6">
        <div class="flex flex-col items-center justify-center w-full mb-4">
            <div class="text-3xl md:text-3xl font-extrabold leading-tight ">
                {{ 'login.title' | transloco:titleParams}}
            </div>
            <div class="mt-0.5 text-base md:text-lg font-medium">
                {{'consent.subtitle' | transloco}}
            </div>
        </div>
         
        <ul *ngIf="subConsents && subConsents.length > 0" class="space-y-4 w-full max-w-2xl">
            <!-- Top-level -->
            <li class="flex items-start space-x-2">
                <div class="custom-checkbox-container mt-1">
                    <input
                        type="checkbox"
                        id="mainConsent"
                        [(ngModel)]="mainConsent"
                        (change)="onMainConsentChange()"
                        class="custom-checkbox visually-hidden"
                    />
                
                    <label for="mainConsent" class="custom-checkbox-label"></label>
                </div>
                <div class="flex flex-col">
                    <label for="mainConsent" class="text-base md:text-md font-semibold">
                        {{'consent.mainconsent' | transloco}}
                    </label>
                    <span class="text-sm md:text-sm">
                        {{'consent.mainconsentdetail' | transloco}}
                    </span>
                </div>
            </li>
            
            <!-- Sub-consents -->
            <div *ngFor="let subConsent of subConsents; let i = index">
                <li class="ml-6 flex items-start space-x-2">
                    <div class="custom-checkbox-container mt-1">
                        <input
                            type="checkbox"
                            [id]="'subConsent' + i"
                            [(ngModel)]="subConsent.checked"
                            
                            (change)="onSubConsentChange()"
                            class="custom-checkbox visually-hidden"
                        />
                
                        <label [for]="'subConsent' + i" class="custom-checkbox-label"></label>
                    </div>
                    <label [for]="'subConsent' + i" class="text-sm md:text-sm">
                        {{subConsent.content}}
                    </label>
                </li>
            </div>
        </ul>
          
        <div *ngIf="apiError" class="w-full max-w-md mt-4 p-3 rounded-md text-red-600 text-base flex items-center justify-center">
            <mat-icon class="mr-2 text-red-500 icon-size-5">error_outline</mat-icon>
            <span>{{ apiError }}</span>
        </div>
        <!-- Button -->
        <button
            (click)="login()"
            class="w-full max-w-md my-button mt-6 md:mt-8 mb-1 bg-teal-700 hover:bg-teal-800 text-white py-4 rounded-full text-base md:text-base font-semibold shadow transition"
        >
            <div class="flex items-center justify-center">
                    <mat-spinner *ngIf="isLoading" [diameter]="20" class="mr-2"></mat-spinner>
                    <span>{{ isLoading ? ('login.logging' | transloco) : ('login.loginBtn' | transloco) }}</span>
            </div>
        </button>
    </div>
  </div>